<template>
  <div id="scrollWrapper" ref="scrollWrapper">
    <slot></slot>
  </div>
</template>
<script>
	import BScroll from 'better-scroll';
	export default {
		name: 'better-scroll',
    data() {
			return {
				scrollWrapper: ''
      }
    },
    destroyed: function () {
      this.destroy();
    },
    props: {
			page: {
				type: Object
      }
    },
    watch: {
			page: function (val, oldVal) {
				console.log('page', val, oldVal);
				const {current_page, per_page, total} = val;
				if(oldVal.current_page === 0 && per_page !== 0) {
					// 初始化进来current_page === 0， 并且第一次获取到数据之后进行初始化
					this.initScroll();
        } else if(current_page <= Math.ceil(total/per_page)){
					// 当前页面 小于||等于 总条数／每页条数 向上取整的时候，refresh数据
              this.refresh();
              this.finishPullUp();
				}
			}
    },
    methods: {
      initScroll: function() {
	      const options = {
		      click: true,
		      probeType: 3,
              scrollX:true,
		      pullDownRefresh: {
			      threshold: 150,
			      stop: 0
		      },
		      pullUpLoad: {
			      threshold: 200
		      }
	      };

	      this.scrollWrapper = new BScroll(this.$refs.scrollWrapper, options);
//	      this.scrollWrapper.on("scrollEnd", res => {
//		      console.log(res)
//	      });
	      this.scrollWrapper.on("pullingUp", res => {
		      const {current_page, per_page, total} = this.page;
		      if(current_page < Math.ceil(total/per_page)){
			      // 当前页面 小于||等于 总条数／每页条数 向上取整的时候，refresh数据
			      this.$emit('pullingUp');
		      }
	      });
	      this.scrollWrapper.on('pullingDown', () => {
		      this.$emit('pullingDown');
        })
      },
      refresh: function() {
//      	console.log('refresh', this.scrollWrapper);
	      this.scrollWrapper.refresh();
      },
	    destroy() {
		    this.scrollWrapper.destroy();
	    },
	    finishPullUp() {
		    this.scrollWrapper.finishPullUp();
      },
      finishPullDown() {
	      this.scrollWrapper.finishPullDown();
      }

    }
	}
</script>
<style lang="scss" scoped>
  #scrollWrapper{
    height: 100%;
    width: 100%;
    position: relative;
    overflow: hidden;
  }
</style>


// WEBPACK FOOTER //
// src/components/BetterScroll/index.vue